export const TermsAndConditionsStatusName = {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending'
};
